<template>
	<!-- 电脑端 -->
	<div>
		<el-col :xs="0" :sm="6" :md="6" :lg="6" :xl="6" :offset="9">
			<div class="userCenter">
				<!-- <div style="width: 100%;height:37px;background-color: #409EFF;color:#fff;margin-bottom: 5px;line-height: 37px;text-align: center;">会员登录</div> -->
				<el-form ref="form" :model="sizeForm" size="small">
					<el-form-item>
						<el-input v-model="sizeForm.username" prefix-icon="el-icon-user" placeholder="请输入账号"></el-input>
					</el-form-item>
					<el-form-item>
						<el-input v-model="sizeForm.password" prefix-icon="el-icon-lock" placeholder="请输入密码" type="password"></el-input>
					</el-form-item>
					<el-form-item size="small" style="text-align: center;">
						<el-button type="primary" @click="onSubmit('sizeForm')">立即登录</el-button>
						<!-- <el-button @click="$router.push('/register')">注册</el-button> -->
					</el-form-item>
				</el-form> 
				<div style="float: right;font-size: 15px;">还没有账号？去<el-button type="text" @click="$router.push('/register')" style="font-size: 15px;">注册</el-button></div>
			</div>
		</el-col>
	<!-- 手机端 -->
		<el-col :xs="24" :sm="0" :md="0" :lg="0" :xl="0">
			<div class="userCenter">
				<!-- <div style="width: 100%;height:37px;background-color: #409EFF;color:#fff;margin-bottom: 5px;line-height: 37px;text-align: center;">会员登录</div> -->
				<el-form ref="form" :model="sizeForm" size="small">
					<el-form-item>
						<el-input v-model="sizeForm.username" prefix-icon="el-icon-user" placeholder="请输入账号"></el-input>
					</el-form-item>
					<el-form-item>
						<el-input v-model="sizeForm.password" prefix-icon="el-icon-lock" placeholder="请输入密码" type="password"></el-input>
					</el-form-item>
					<el-form-item size="small" style="text-align: center;">
						<el-button type="primary" @click="onSubmit('sizeForm')" style="width: 100%;">立即登录</el-button>
						<!-- <el-button @click="$router.push('/register')">注册</el-button> -->
					</el-form-item>
				</el-form> 
				<div style="float: right;font-size: 15px;margin-bottom:50px">还没有账号？去<el-button type="text" @click="$router.push('/register')" style="font-size: 15px;">注册</el-button></div>
			</div>
		</el-col>
	</div>
</template>

<script>
	export default{
		metaInfo() {
		  return {
			title: this.metaName,
			meta: [{ charset: "utf-8",
			},{ 
				name: "keywords", 
			    content: this.metaKeywords,
			},{ 
				name: "description", 
			    content: this.metaDecs,
			  }],
		  }
		},
		data() {
			return{
				domain:this.$utils.httpUrl,
				metaName: "",
				metaKeywords: "",
				metaDecs: "",
				sizeForm: {
				  username: '',
				  password: ''
				}
			}
		},
		created() {
			this.$axios({
				url:this.$utils.httpApi + 'index/webconfig'
			}).then(res=>{
				this.metaName = res.data.data.webtitle
				this.metaDecs = res.data.data.webdescription
				this.metaKeywords = res.data.data.webkeywords
			})
		},
		methods:{
			onSubmit() {
				this.$axios({
					method:'post',
					url:this.$utils.httpApi + 'user/login',
					data:this.sizeForm
				}).then(res=>{
					if(res.data.code == 1){
						window.localStorage.setItem('token',res.data.data.userinfo.token)
						this.$message.success(res.data.msg)
						this.$router.push('/')
						
					}else{
						this.$message.error(res.data.msg)
						
					}
				})
			},
		},
	}
</script>

<style>
</style>